export const PHONE_DISPLAY = "8854865454";
export const PHONE_INTL = "918854865454";

export function whatsappLink(message = "Hi Nidan Diagnostic Centre, I'd like to book an appointment.") {
  const encoded = encodeURIComponent(message);
  return `https://wa.me/${PHONE_INTL}?text=${encoded}`;
}

export function buildAppointmentMessage({ name, phone, service, date, time, message }) {
  return [
    "Hello Nidan Diagnostic Centre,",
    "",
    "I'd like to book an appointment.",
    "",
    `Name: ${name || "-"}`,
    `Phone: ${phone || "-"}`,
    `Service: ${service || "-"}`,
    `Preferred Date: ${date || "-"}`,
    `Preferred Time: ${time || "-"}`,
    message ? `Message: ${message}` : null,
    "",
    "Please confirm my slot. Thank you.",
  ]
    .filter(Boolean)
    .join("\n");
}
